import { AvailableMarkets, LoanTermValueDefaults } from '~/Interfaces';

const defaultLoanTerm: LoanTermValueDefaults = {
  defaultValue: 6,
  min: 3,
  max: 18,
  step: 1,
};

const defaultLoanTerms: AvailableMarkets<LoanTermValueDefaults> = {
  se: {
    ...defaultLoanTerm,
  },
  no: {
    ...defaultLoanTerm,
  },
  nl: {
    ...defaultLoanTerm,
  },
  fi: {
    ...defaultLoanTerm,
    min: 6,
  },
  dk: {
    ...defaultLoanTerm,
  },
  be: {
    ...defaultLoanTerm,
  },
};

export const getDefaultLoanTerm = (market: string) =>
  defaultLoanTerms[
    market.toLowerCase() as keyof AvailableMarkets<LoanTermValueDefaults>
  ];
